// extracted by mini-css-extract-plugin
export default {"importanComment":"_7d14316d8b8cecb0"};